import styles from './index.less?modules';
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import { isEmptyObject } from '@/utils/comUtil';
import { Radio } from 'antd';
import DataTable from '@/containers/data_table_ml/DataTable';
import { fieldType } from '@/constants.js';
import Search from './components/search/Search';
import ButtonML from '@/components/button_ml/ButtonML';

const Ffp = (props) => {
  // 发起请求
  const dispatch = useDispatch();
  const { handleCancel, changeOptions } = props;
  const fieldPackageList = useSelector(
    (state) => state.bre.allFieldPackageList,
  );
  const fieldPackageDetailList = useSelector(
    (state) => state.bre.fieldPackageDetailList,
  );
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['bre/getFieldPackageDetail'];
  const [seledId, setSeledId] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [seledRows, setSeledRows] = useState(null);
  const onChange = (e) => {
    setSeledId(e.target.value);
  };
  //获取字段包列表
  const getAllFieldPackage = useCallback(() => {
    dispatch({
      type: 'bre/getAllFieldPackage',
    });
  }, [dispatch]);
  //获取字段包详情
  const getFieldPackageDetails = useCallback(() => {
    if (!seledId) {
      return;
    }
    dispatch({
      type: 'bre/getFieldPackageDetails',
      payload: {
        values: {
          fieldPackageId: seledId,
        },
      },
    });
  }, [dispatch, seledId]);
  //清空列表的数据
  const resetFieldPackageDetails = () => {
    dispatch({
      type: 'bre/resetFieldPackageDetails',
    });
  };
  const columns = [
    {
      title: '字段编号',
      dataIndex: 'fieldNumber',
      key: 'fieldNumber',
      width: '30%',
    },
    {
      title: '字段名称',
      dataIndex: 'fieldName',
      key: 'fieldName',
      width: '30%',
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: '30%',
      render: (text) => fieldType[text],
    },
  ];
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      setSeledRows(selectedRows);
    },
    onSelectAll: (selected, selectedRows) => {
      setSeledRows(selectedRows);
    },
    columnWidth: 40,
  };
  const handleSubmit = () => {
    handleCancel();
    resetFieldPackageDetails();
    changeOptions(seledRows);
  };
  useEffect(() => {
    getAllFieldPackage();
  }, [getAllFieldPackage]);
  useEffect(() => {
    getFieldPackageDetails();
  }, [getFieldPackageDetails]);
  return (
    <div className={styles.box}>
      <div className={styles.left}>
        <div className={styles.left_top}>字段类别选择</div>

        <Radio.Group onChange={onChange} value={seledId}>
          {!isEmptyObject(fieldPackageList) &&
            fieldPackageList.map((item) => {
              return (
                <Radio value={item.id} key={item.id} className={styles.radio}>
                  {item.name}
                </Radio>
              );
            })}
        </Radio.Group>
      </div>

      <div className={styles.right}>
        <Search setSearchValue={setSearchValue} />
        <div className={styles.right_table}>
          <DataTable
            className="demo-test"
            columns={columns}
            rowSelection={rowSelection}
            scroll={{ y: 'calc(70vh - 48px * 5)' }}
            style={{ height: 'calc(70vh - 48px * 4)' }}
            dataSource={
              fieldPackageDetailList &&
              fieldPackageDetailList.filter((item) =>
                item.fieldName.includes(searchValue || ''),
              )
            }
            loading={loading}
            isTree={true}
          />
        </div>
        <div className={styles.right_top}>
          <ButtonML size="large" value="提交" onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};
export default Ffp;
